import { ISODateType } from '@principle-theorem/shared';
import { Gender } from '../../patient/patient';
import { IMohPdfTreatment } from './moh';

export interface IMohSdsSummaryData {
  claimUid: string;
  payeeNumber: string;
  agreementNumber: string;
  agreementHolderName: string;
  practitionerName: string;
  dcnzNumber: string;
  numberOfPatients: number;
  totalExGst: number;
  gstAmount: number;
  totalIncGst: number;
  signatureDate: ISODateType;
}

export enum MohSdsTreatmentReason {
  AsReferred = 'asReferred',
  EmergencyCohsEnrolled = 'emergencyCohsEnrolled',
  TreatmentCohsWithoutReferral = 'treatmentCohsWithoutReferral',
  EmergencyAdolescentOtherProvider = 'emergencyAdolescentOtherProvider',
  EmergencyNotEnrolled = 'emergencyNotEnrolled',
}

export interface IMohSdsIndividualTreatmentData {
  patientNhiNumber: string;
  patientFirstName: string;
  patientLastName: string;
  patientAddress: string;
  patientDateOfBirth: ISODateType;
  patientGender: Gender;
  schoolOrOralHealthCentre: string;
  standardTreatments: IMohPdfTreatment[];
  preApprovalTreatments: IMohPdfTreatment[];
  appointmentDate?: ISODateType;
  approvalNumber?: string;
  treatmentReason: MohSdsTreatmentReason;
  schoolTown: string;
  usualOralHealthPractitioner: string;
  practitionerTown: string;
  totalExGst: number;
  cohsReferralNumber?: string;
}
